import React, { useEffect, useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { AuditEvent } from '../../components/services/auditService';
import EventDetail from './EventDetail';

interface EventDetailDrawerProps {
  event: AuditEvent | null;
  /** Action code -> customer-facing name, for the heading. */
  actionNames?: Record<string, string>;
  onClose: () => void;
}

const EventDetailDrawer = ({ event, actionNames = {}, onClose }: EventDetailDrawerProps) => {
  // The page clears `event` on close; keep rendering the last one so the panel slides out with its content
  // instead of going blank first.
  const [shownEvent, setShownEvent] = useState<AuditEvent | null>(event);
  useEffect(() => {
    if (event) setShownEvent(event);
  }, [event]);

  return (
    <Dialog open={!!event} onClose={onClose} className="relative z-50">
      <DialogBackdrop transition className="fixed inset-0 bg-black/60 transition-opacity duration-300 ease-out data-[closed]:opacity-0" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
          <DialogPanel
            transition
            className="pointer-events-auto h-full w-screen max-w-2xl transform overflow-y-auto border-l border-[#474646] bg-[#0f0f0f] p-6 shadow-2xl transition duration-300 ease-out will-change-transform data-[closed]:translate-x-full data-[leave]:ease-in"
          >
            <div className="mb-4 flex items-center justify-between">
              <DialogTitle className="text-base font-semibold text-white">Event details</DialogTitle>
              <button type="button" aria-label="Close" onClick={onClose} className="rounded p-1 text-gray-400 transition hover:bg-[#1f1f1f] hover:text-white">
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            {shownEvent && <EventDetail event={shownEvent} actionName={actionNames[shownEvent.action]} />}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default EventDetailDrawer;
